export default "__VITE_ASSET__OWJDmQP4__"